const initState = {
    transactions: []
};

const queueReducer = (state = initState, action) => {
    switch(action.type){
        case "ADD_TO_QUEUE":
            return{...state, transactions: state.transactions.concat(action.data)};
        case "REMOVE_FROM_QUEUE":
            return{...state, transactions: state.transactions.filter(tran => tran.transactionId != action.data.transactionId)}
        case "RESET_QUEUE":
            return{...state, transactions: []}
        default:
            return state;
    }
};

export default queueReducer;